import axios from 'axios'
import * as ls from 'local-storage'

const API_URL = process.env.REACT_APP_API || window.Cypress?.env('api')
const endpoints = {
    baskets: {
        add: `${API_URL}/baskets`,
        get: id => `${API_URL}/baskets/${id}`,
        update: id => `${API_URL}/baskets/${id}`,
        addPromotionCodesToBasket: id => `${API_URL}/baskets/${id}/promotion-codes`,
    },
}

export const getToken = () => {
    return ls.get('token')
}

export const addBasketRequest = async props => {
    const { user, id, email, currency = 'GBP', lines } = props
    const token = getToken()
    const request = {
        currency,
        lines,
        source: 'telephone',
    }

    if (id) {
        request.user = `/users/${id}`
    }

    if (email) {
        request.email = email
    }

    const data = await axios
        .post(endpoints.baskets.add, request, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        })
        .catch(err => {
            return Promise.reject(err)
        })

    ls.set(`${user.profile.id}_basket`, data.data.id)
    return data
}

export const updateBasketRequest = async props => {
    const { id, lines, ...restProps } = props
    const token = getToken()

    return await axios
        .put(
            endpoints.baskets.update(id),
            { lines, ...restProps },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        )
        .catch(err => {
            return Promise.reject(err)
        })
}

export const getBasket = async props => {
    const { id } = props
    const token = getToken()

    return await axios
        .get(`${endpoints.baskets.get(id)}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        })
        .catch(err => {
            return Promise.reject(err)
        })
}

export const updateBasket = async ({ adminUser, products = [], ...basketData }) => {
    const lineItems = []

    products.forEach(product => {
        const line = {
            quantity: product.quantity !== null ? Number(product.quantity) : 1,
        }

        if (product?.variantId) {
            line.productVariant = product.variantId
        } else {
            line.product = product.id
        }

        lineItems.push(line)
    })

    const { data } = await updateBasketRequest({
        id: ls.get(`${adminUser.profile.id}_basket`),
        lines: lineItems,
        ...basketData,
    }).catch(err => {
        return Promise.reject(err)
    })
    return data
}

export const addBasket = async ({ user, products = [] }) => {
    const email = user?.guest_user === false ? user?.username : ''

    const lineItems = products.map(product => {
        return {
            quantity: product?.quantity || 1,
            product: product?.id || null,
        }
    })

    const { data } = await addBasketRequest({
        user: user,
        id: user?.id ? user.id : null,
        email: email,
        lines: lineItems,
    }).catch(err => {
        return Promise.reject(err)
    })
    return data
}

export const addPromotionCodesToBasket = async ({ basketId, promoCodes }) => {
    const token = getToken()

    return await axios
        .put(
            endpoints.baskets.addPromotionCodesToBasket(basketId),
            { promoCodes },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        )
        .catch(err => {
            return Promise.reject(err)
        })
}
